import dateTimeFormat from "@/core/filters/dateTimeFormat.filter";
import { ROLE_PERMISSION } from "@/core/api";
import { apiHelper } from "@/core/utils";
import {
  LOADING_OPEN_LOADING,
  LOADING_CLOSE_LOADING,
} from "@/core/store/loading.module";

/* Define Module Name */
const MODULE_NAME = "rolePermission/";

/* Define Action Name */
const A_GET_PERMISSIONS = "getPermissions";
const A_GET_PERMISSION = "getPermission";
const A_CREATE_PERMISSION = "createPermission";
const A_UDPATE_PERMISSION = "updatePermission";
const A_DELETE_PERMISSION = "deletePermission";

/* Define Reset State Action Name */
const A_INITIAL_GET_PERMISSIONS_STATE = "initialGetPermissionsState";
const A_INITIAL_GET_PERMISSION_STATE = "initialGetPermissionState";
const A_INITIAL_CREATE_PERMISSION_STATE = "initialCreatePermissionState";
const A_INITIAL_UPDATE_PERMISSION_STATE = "initialUpdatePermissionState";
const A_INITIAL_DELETE_PERMISSION_STATE = "initialDeletePermissionState";

/* Define Getter Name */

/* Define Mutation Name */
const M_GET_PERMISSIONS = "setGetPermissions";
const M_GET_PERMISSION = "setGetPermission";
const M_CREATE_PERMISSION = "setCreatePermission";
const M_UPDATE_PERMISSION = "setUpdatePermission";
const M_DELETE_PERMISSION = "setDeletePermission";

/* Define Reset State Mutation Name */
const M_INITIAL_GET_PERMISSIONS_STATE = "setInitialGetPermissionsState";
const M_INITIAL_GET_PERMISSION_STATE = "setInitialGetPermissionState";
const M_INITIAL_CREATE_PERMISSION_STATE = "setInitialCreatePermissionState";
const M_INITIAL_UPDATE_PERMISSION_STATE = "setInitialUpdatePermissionState";
const M_INITIAL_DELETE_PERMISSION_STATE = "setInitialDeletePermissionState";

/* Define Export Name */
export const ROLE_PERMISSION_GET_PERMISSIONS = MODULE_NAME + A_GET_PERMISSIONS;
export const ROLE_PERMISSION_GET_PERMISSION = MODULE_NAME + A_GET_PERMISSION;
export const ROLE_PERMISSION_CREATE_PERMISSION =
  MODULE_NAME + A_CREATE_PERMISSION;
export const ROLE_PERMISSION_UPDATE_PERMISSION =
  MODULE_NAME + A_UDPATE_PERMISSION;
export const ROLE_PERMISSION_DELETE_PERMISSION =
  MODULE_NAME + A_DELETE_PERMISSION;

/* Define Reset State Name */
export const ROLE_PERMISSION_INITIAL_GET_PERMISSIONS_STATE =
  MODULE_NAME + A_INITIAL_GET_PERMISSIONS_STATE;
export const ROLE_PERMISSION_INITIAL_GET_PERMISSION_STATE =
  MODULE_NAME + A_INITIAL_GET_PERMISSION_STATE;
export const ROLE_PERMISSION_INITIAL_CREATE_PERMISSION_STATE =
  MODULE_NAME + A_INITIAL_CREATE_PERMISSION_STATE;
export const ROLE_PERMISSION_INITIAL_UPDATE_PERMISSION_STATE =
  MODULE_NAME + A_INITIAL_UPDATE_PERMISSION_STATE;
export const ROLE_PERMISSION_INITIAL_DELETE_PERMISSION_STATE =
  MODULE_NAME + A_INITIAL_DELETE_PERMISSION_STATE;

const state = {
  permissions: {
    code: 0,
    complete: false,
    data: null,
    message: null,
    pagination: {
      currentPage: 0,
      total: 0,
      pageSize: 0,
      lastPage: 0,
    },
  },
  permission: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  createPermission: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  updatePermission: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
  deletePermission: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
};

//Getters
const getters = {};

// Actions
const actions = {
  [A_GET_PERMISSIONS]({ dispatch, commit }, { data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    ROLE_PERMISSION.getPermissions(data)
      .then((response) => {
        result = response;
        commit(M_GET_PERMISSIONS, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_GET_PERMISSIONS, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_GET_PERMISSION]({ dispatch, commit }, { id }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    ROLE_PERMISSION.getPermission(id)
      .then((response) => {
        result = response;
        commit(M_GET_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_GET_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_CREATE_PERMISSION]({ dispatch, commit }, { data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    ROLE_PERMISSION.createPermission(data)
      .then((response) => {
        result = response;
        commit(M_CREATE_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_CREATE_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_UDPATE_PERMISSION]({ dispatch, commit }, { id, data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    ROLE_PERMISSION.updatePermission(id, data)
      .then((response) => {
        result = response;
        commit(M_UPDATE_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_UPDATE_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_DELETE_PERMISSION]({ dispatch, commit }, { id }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    ROLE_PERMISSION.deletePermission(id)
      .then((response) => {
        result = response;
        commit(M_DELETE_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_DELETE_PERMISSION, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_INITIAL_GET_PERMISSIONS_STATE]({ commit }) {
    commit(M_INITIAL_GET_PERMISSIONS_STATE);
  },
  [A_INITIAL_GET_PERMISSION_STATE]({ commit }) {
    commit(M_INITIAL_GET_PERMISSION_STATE);
  },
  [A_INITIAL_CREATE_PERMISSION_STATE]({ commit }) {
    commit(M_INITIAL_CREATE_PERMISSION_STATE);
  },
  [A_INITIAL_UPDATE_PERMISSION_STATE]({ commit }) {
    commit(M_INITIAL_UPDATE_PERMISSION_STATE);
  },
  [A_INITIAL_DELETE_PERMISSION_STATE]({ commit }) {
    commit(M_INITIAL_DELETE_PERMISSION_STATE);
  },
};

// Mutations
const mutations = {
  [M_GET_PERMISSIONS](state, result) {
    if (result.code === 200) {
      let d = result.data;
      let p = result.pagination;
      state.permissions = {
        code: result.code,
        complete: true,
        data: d.map((x, index) => {
          return {
            no: index + 1,
            id: x.id,
            createdAt: x.createdAt,
            updatedAt: x.updatedAt,
            roleName: x.roleName,
            adGroupName: x.adGroupName,
            status: Boolean(x.status),
            modules: x.modules,
            modulesString: x.modulesString,
          };
        }),
        message: null,
        pagination: {
          currentPage: p.current_page,
          total: p.total,
          pageSize: p.page_size,
          lastPage: p.last_page,
        },
      };
      apiHelper.checkToken();
    } else {
      state.permissions = {
        code: result.code,
        complete: true,
        data: null,
        message: apiHelper.sortOutMessage(result.msg),
        pagination: {
          currentPage: 0,
          total: 0,
          pageSize: 0,
          lastPage: 0,
        },
      };
    }
  },
  [M_GET_PERMISSION](state, result) {
    if (result.code === 200) {
      let d = result.data;
      state.permission = {
        code: result.code,
        complete: true,
        data: {
          id: d.id,
          createdAt: d.createdAt,
          updatedAt: d.updatedAt,
          roleName: d.roleName,
          adGroupName: d.adGroupName,
          status: Boolean(d.status),
          modules: d.modules,
          modulesString: d.modulesString,
        },
        message: null,
      };
      apiHelper.checkToken();
    } else {
      state.permission = {
        code: result.code,
        complete: true,
        data: null,
        message: apiHelper.sortOutMessage(result.msg),
      };
    }
  },
  [M_UPDATE_PERMISSION](state, result) {
    state.updatePermission = {
      code: result.code,
      complete: true,
      data: result.data,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_CREATE_PERMISSION](state, result) {
    state.createPermission = {
      code: result.code,
      complete: true,
      data: result.data,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_DELETE_PERMISSION](state, result) {
    state.deletePermission = {
      code: result.code,
      complete: true,
      data: result.data,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_INITIAL_GET_PERMISSIONS_STATE](state) {
    state.permissions = {
      code: 0,
      complete: false,
      data: null,
      message: null,
      pagination: {
        currentPage: 0,
        total: 0,
        pageSize: 0,
        lastPage: 0,
      },
    };
  },
  [M_INITIAL_GET_PERMISSION_STATE](state) {
    state.permission = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_CREATE_PERMISSION_STATE](state) {
    state.createPermission = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_UPDATE_PERMISSION_STATE](state) {
    state.updatePermission = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
  [M_INITIAL_DELETE_PERMISSION_STATE](state) {
    state.deletePermission = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
